import { LeadCurd } from "./leadCrud";

export default function TeamLeads() {
  return <LeadCurd name="团队客户" type="team" router="teamLeads" />;
}
